<script>
import qlEditor from 'vue-quill-editor'
export default {
  components: {
    qlEditor
  },
  props: {
    eventInfoModel: {
      createTime: null,
      createUser: '',
      eventDate: '',
      eventId: '',
      eventName: '',
      eventNote: '',
      eventPhotoUrl: '',
      updateTime: null,
      updateUser: ''
    },
    option: {
      imgs: null,
      file: null,
      chooseImageFlag: false
    },
    shiftBasicModel: {},
    // 根据flag显示不同的标题
    functionFlag: '',
    shiftList: {
      // frontId: ''
    },
    shiftConnectList: {},
    connectGroupList: {},
    connectGroupHtml: ''
  },
  filters: {
    dateWeek (eventDate) {
      if (eventDate === null || eventDate === '' || eventDate === undefined) {
        return ''
      } else {
        let weeks = ['日', '月', '火', '水', '木', '金', '土']
        let convDate = eventDate.substring(0, 4) + ' 年 '
        if (eventDate.charAt(4) === '0') {
          convDate = convDate + eventDate.charAt(5) + ' 月 '
        } else {
          convDate = convDate + eventDate.substring(4, 6) + ' 月 '
        }
        if (eventDate.charAt(6) === '0') {
          convDate = convDate + eventDate.charAt(7) + ' 日 '
        } else {
          convDate = convDate + eventDate.substr(6, 2) + ' 日 '
        }
        let datetemp = eventDate.substring(0, 4) + '/' + eventDate.substring(4, 6) + '/' + eventDate.substr(6, 2)
        let newDate = new Date(datetemp)
        let week = weeks[newDate.getDay()]
        convDate = convDate + ' ( ' + week + ' )'
        return convDate
      }
    },
    // 获取08：40的日期格式
    hourMin (dateStr) {
      if (dateStr === null || dateStr === '') {
        return ''
      }
      return dateStr.substr(8, 2) + ':' + dateStr.substr(10, 2)
    },
    // 获取 08 时台格式
    hour (dateStr) {
      if (dateStr === null || dateStr === '') {
        return ''
      }
      return dateStr.substr(8, 2)
    }
  },
  data () {
    return {
      resolve: '',
      title:
      ['便を登録',
        '便を編集',
        '便を登録(増便)',
        'このルートで便を登録'
      ],
      route: ''
    }
  },
  mounted () {

  },
  methods: {
    submit () {
      this.resolve('submit')
    },
    // 显示confirm弹出,并创建promise对象，给父组件调用
    confirm () {
      // 返回promise对象,给父级组件调用
      return new Promise((resolve) => {
        this.resolve = resolve
      })
    },
    getPassengerName (startPassengers) {
      if(this.functionFlag === '3'){
        let name = ''
        if (startPassengers.length > 0) {
          name = '乗車者:' + '&nbsp;&nbsp'
          for (let startPassenger of startPassengers) {
            name += startPassenger.name
            name += '、'
          }
          name = name.substring(0, name.length - 1)
        }
        return name
      }
        return ''
    }
  }
}
</script>
<template>
   <div class="col-md-12 column">
    <div class="modal fade padding0" id="modal-container-shift-detail-event" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <div id="div_layer" class="modal-dialog" style="width:73.3%;">
        <div class="modal-content">
            <div class="modal-header" style="text-align:center; border-bottom:0px">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true" >
                <img height="30px" src="@/assets/X.png" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;"/>
              </button>
              <span class="modal-title F3-M-27" v-if="this.functionFlag==='1'">{{title[1]}}</span>
              <span class="modal-title F3-M-27" v-else-if="this.functionFlag==='0'">{{title[0]}}</span>
              <span class="modal-title F3-M-27" v-else-if ="this.functionFlag === '3'">{{title[2]}}</span>
              <span class="modal-title F3-M-27" v-else>{{title[3]}}</span>
            </div>
            <!-- 追加ボタン対応エリア -->
            <div>
              <div v-for="(item, index) in shiftList" :key="index">
                <div class="modal-body">
                    <div class="col-md-12 column">
                      <table class="table table-bordered window-table">
                        <tbody>
                          <tr>
                            <td width='12%' class="td-key F3-R-15 bgc8">便名</td>
                            <td class="td-value F3-M-18" colspan="3">{{item.shiftBasic.title}}</td>
                          </tr>
                          <tr v-if="item.shiftBasic.shiftId !== ''">
                            <td class="td-key F3-R-15 bgc8">便<span> ID</span></td>
                            <td class="td-value F3-M-18" colspan="3">{{item.shiftBasic.shiftId}}</td>
                          </tr>
                          <tr>
                            <td class="td-key F3-R-15 bgc8">ルート</td>
                            <td class="td-value F3-M-18" colspan="3">{{item.shiftBasic.routeName}}</td>
                          </tr>
                          <tr v-show="index===0">
                            <td class="td-key F3-R-15 bgc8">行き/帰り</td>
                            <td class="td-value F3-M-18" colspan="3">
                              <div v-if="shiftList[0].shiftBasic.shiftFlag=== '1'">帰り</div>
                              <div v-else>行き</div>
                            </td>
                          </tr>
                          <tr v-show="index===0">
                            <td class="td-key F3-R-15 bgc8">地区フィルター</td>
                            <td class="td-value F3-M-18" colspan="3">{{item.shiftBasic.areaName}}</td>
                          </tr>
                          <tr v-show="index===0">
                            <td class="td-key F3-R-15 bgc8">運行日</td>
                            <td class="td-value F3-M-18" colspan="3">{{item.shiftBasic.moveShiftTime | dateWeek}}</td>
                          </tr>
                          <tr v-for="(shiftPasspoint, passpointIndex) in item.shiftPasspointList" :key="shiftPasspoint.stationId">
                            <td width='12%' class="td-key F3-R-15 bgc8">
                              <span v-if="passpointIndex===0">出発地</span>
                              <span v-else-if="passpointIndex===item.shiftPasspointList.length - 1">終着地</span>
                              <span v-else-if="shiftPasspoint.routeType==null || shiftPasspoint.routeType==='0'">停留所{{shiftPasspoint.stationIndex!=null&&shiftPasspoint.stationIndex!==""?shiftPasspoint.stationIndex:passpointIndex}}</span>
                              <span v-else>経由地{{shiftPasspoint.index}}</span>
                            </td>
                            <td width='38%' v-if="item.shiftBasic.reserveNumber===0" class="td-value F3-M-18">
                              <span v-if="functionFlag ==='1' || functionFlag ==='3'">{{shiftPasspoint.stationName}}&nbsp;&nbsp;&nbsp;<span v-html="getPassengerName(shiftPasspoint.startPassengers)"></span></span>
                              <span v-else>{{shiftPasspoint.stationName}}</span>
                            </td>
                            <td width='38%' v-else :class="shiftPasspoint.stopFlag===true || shiftPasspoint.stopFlag=== undefined ?'td-value F3-M-18':'td-value1 F9-M-18'">
                              <span v-if="functionFlag ==='0'">{{shiftPasspoint.stationName}}&nbsp;&nbsp;&nbsp;<span v-html="getPassengerName(shiftPasspoint.startPassengers)"></span></span>
                              <span v-else-if="shiftPasspoint.stopFlag===true">{{shiftPasspoint.stationName}}&nbsp;&nbsp;&nbsp;<span v-html="getPassengerName(shiftPasspoint.startPassengers)"></span></span>
                              <span v-else><span class="F3-M-18">↓</span>{{shiftPasspoint.stationName}}&nbsp;&nbsp;&nbsp;<span v-html="getPassengerName(shiftPasspoint.startPassengers)"></span></span>
                            </td>
                            <td width='12%' class="td-key F3-R-15 bgc8">
                              <span v-if="passpointIndex===0">出発予定時間</span>
                              <span v-else>到着予定時間</span>
                            </td>
                            <td width='38%' class="td-value F3-M-18">
                              <!-- 行き出発地 -->
                              <span v-if="shiftList[0].shiftBasic.shiftFlag==='0' && passpointIndex===0">{{shiftPasspoint.startEstimateTime | hourMin}}</span>
                              <!-- 帰り終着地 -->
                              <span v-else-if="shiftList[0].shiftBasic.shiftFlag==='1' && passpointIndex===item.shiftPasspointList.length-1">{{shiftPasspoint.arriveEstimateTime| hourMin}}</span>
                              <!-- 帰り出発地 -->
                              <span v-else-if="passpointIndex===0">{{shiftPasspoint.startEstimateTime | hourMin}}</span>
                              <!-- その他 -->
                              <span v-else>{{shiftPasspoint.arriveEstimateTime | hourMin}}</span>
                            </td>
                          </tr>
                          <tr v-show="index===0">
                            <td class="td-key F3-R-15 bgc8">利用料金</td>
                            <td class="td-value F3-M-18" colspan="3">{{item.shiftBasic.shiftCost}}円</td>
                          </tr>
                          <tr>
                            <td class="td-key F3-R-15 bgc8">フリガナ</td>
                            <td class="td-value F3-M-18" colspan="3">{{item.shiftBasic.driverKanaName}}</td>
                          </tr>
                          <tr>
                            <td class="td-key F3-R-15 bgc8">ドライバー</td>
                            <td class="td-value F3-M-18" colspan="3" >{{item.shiftBasic.driverName}}</td>
                          </tr>
                          <tr>
                            <td class="td-key F3-R-15 bgc8">車両</td>
                            <td class="td-value F3-M-18" colspan="3">{{item.shiftBasic.vehicleName}}&nbsp;&nbsp;&nbsp;ID:{{item.shiftBasic.displayVehicleId}}&nbsp;&nbsp;&nbsp;定員{{item.shiftBasic.passengerNumber}}名
                            </td>
                          </tr>
                          <tr>
                            <td class="td-key F3-R-15 bgc8">コメント</td>
                            <td class="td-value F3-M-18" colspan="3" >{{item.shiftBasic.comment}}</td>
                          </tr>
                        </tbody>
                      </table>

                    </div>
                    <br>
                </div>
              </div>
              <div class="modal-body" v-if="shiftList != null && shiftList.length > 0">
                <div class="col-md-12 column">
                  <table v-if="shiftList[0].shiftBasic.shiftType === '2'" class="table table-bordered window-table">
                    <col style="width: 25%"/>
                    <col style="width: 15%"/>
                    <col style="width: 60%"/>
                    <tbody>
                      <tr>
                        <td class="td-key bgc3 F2-M-19" colspan="3">イべント項目</td>
                      </tr>
                      <tr>
                        <td class="td-value F3-M-18" rowspan="3" style="padding:10px">
                          <div class="img-bg">
                            <img v-show="option.imgs" :src="option.imgs" class="img-style"/>
                            <div v-show="!option.imgs" class="bgc10 F2-M-18">No Image</div>
                          </div>
                        </td>
                        <td class="td-key F3-R-15 bgc8">イべント名</td>
                        <!-- <td class="td-value F3-M-18 word-breaker">{{eventInfoModel.eventName}}</td> -->
                        <td class="td-value F3-M-18 word-breaker">{{shiftList[0].shiftEvent.eventName}}</td>
                      </tr>
                      <tr>
                        <td class="td-key F3-R-15 bgc8" >開催日</td>
                        <!-- <td class="td-value F3-M-18">{{eventInfoModel.eventDate}}</td> -->
                        <td class="td-value F3-M-18">{{shiftList[0].shiftEvent.eventDate}}</td>
                      </tr>
                      <tr>
                        <td class="td-key F3-R-15 bgc8" style="height:300px; line-height:300px">開催概要</td>
                        <td class="td-value F3-M-18">
                          <!-- <div class="ql-editor" style="padding:0" v-html="this.eventInfoModel.eventNote"></div> -->
                          <div class="ql-editor" style="padding:0" v-html="shiftList[0].shiftEvent.eventNote"></div>
                      </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <!-- 接続情報表示エリア -->
            <div class="connect-area" v-if="connectGroupList.length > 0">
              <div class="modal-body connect-header F3-M-27">乗り継ぎ接続の確認 [{{shiftList[0].shiftBasic.shiftFlag == 0 ? '行き':'帰り'}}]</div>
                <div v-html="connectGroupHtml"></div>
            </div>
            <div>
              <button class="window-button" @click="submit" data-dismiss="modal">確定</button>
            </div>
        </div>
      </div>
    </div>
   </div>
</template>
<style lang="scss" scoped>
@import "../assets/css/C00.css";
// 表格内的文本换行
.word-breaker{
  word-break: break-all;
}
.ql-editor{
  height:300px;
  padding: 0%;
  font-size: 1.09vw;
  word-break:break-all
}
.padding0{
  padding-left: 0px;
}
.modal-header{
  border-bottom: 0px;
}
.modal-body{
  padding-left: 40px;
  padding-right: 40px;
  height: 100%;
}
.img-bg{
  color: #fff;
  width:100%;
  height: 200px;
  line-height: 200px;
  text-align: center;
}
.img-style{
  height: 100%;
  width: 100%;
}
  //表格
.window-table{
  font-size: 18px;
  border: 1px solid #959595;
  }
 //边框
.table-bordered>tbody>tr>td{
  border: 1px solid #959595;
}
.td-key{
vertical-align: middle;
 border: 1px solid #959595;
}
//关于值的列的设置（深色）
.td-value{
  padding:9px;
  padding-left: 20px;
  text-align: left;
  border: 1px solid #959595;
}
.td-value1{
  padding:9px;
  padding-left: 20px;
  text-align: left;
  border: 1px solid #959595;
  // color:#bbbbbb;
}

.connect-header{
  // margin-top: 30px;
}
.connect-area /deep/{

  .connect-group{
    margin: 10px auto 0 auto;
    width: 92%;
    padding: 20px;
    border: 1px solid #959595;
  }
  .connect-row{
    display: flex;
  }
  .connect-arrow{
    width: 100%;
    text-align: center;
  }
  .connect-item{
    // width: 50%;
    // max-width: 390px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/ShiftDetailEventWindowMask.vue